// extracted by mini-css-extract-plugin
module.exports = {"modal":"About_modal__1pLDN","open":"About_open__hau0I","close":"About_close__1IoIh","guidedSessionLink":"About_guidedSessionLink__ei6A9"};